<app-settings-sub-header
    [headerData]="subHeaderData"
    [cdmsSettingForm]="cdmsFormGroup"
    [generalTabIndex]="generalTabIndex"
    [cdmsSettingsForm]="cdmsSettingsForm"
></app-settings-sub-header>

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card card-custom gutter-b card-stretch">
                <div class="card-body">
                    <div class="setting_sec">
                        <div class="setting_tab" id="setting_tab">
                            <mat-tab-group (selectedTabChange)="tabChanged($event)" class="tab-wrapper">
                                <mat-tab label="{{ lookupTabTitle }}" *ngIf="viewDatabaseLookupTab" [aria-label]="lookupTabTitle">
                                    <app-db-lookup-grade-matrix
                                        [form]="cdmsFormGroup"
                                        [isDbLookUpView]="viewDatabaseLookupTab"
                                        [isGradeMatrixView]="viewGradeMatrixTab"
                                    ></app-db-lookup-grade-matrix>
                                </mat-tab>

                                <mat-tab label="Manage Certificates" *ngIf="viewCertificatesTab" [aria-label]="'Manage Certificates'">
                                    <app-grade-matrix [cdmsFormGroup]="cdmsFormGroup"></app-grade-matrix>
                                </mat-tab>
                            </mat-tab-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
